import { QuizTemplate } from "./types";
import { promptEnd, promptIntro } from "./utils";

export const beginnerCommonVerbs: QuizTemplate = {
  slug: "beginner-common-verbs",
  titleHandle: "guide.beginnerCommonVerbs.title",
  shortTextHandle: "guide.beginnerCommonVerbs.shortText",
  longTextHandle: "guide.beginnerCommonVerbs.longText",
  level: "easy",
  questionPrompts: (userLanguageName: string, practiceLanguageName: string) => [
    {
      title: "Identify Basic Verbs",
      prompt:
        promptIntro(userLanguageName, practiceLanguageName) +
        `to identify basic verbs in ${practiceLanguageName}. 
      Focus on essential verbs such as 'to be', 'to have', 'to go', and 'to do'. Explain how these verbs are used and conjugated in simple present tense.` +
        promptEnd(userLanguageName, practiceLanguageName),
    },
    {
      title: "Forming Simple Sentences",
      prompt:
        promptIntro(userLanguageName, practiceLanguageName) +
        `to form simple sentences using common verbs in ${practiceLanguageName}. 
      Provide examples of simple sentences like 'I am', 'She has', 'We go', and 'They do'. Include pronouns and demonstrate how verbs change with different pronouns.` +
        promptEnd(userLanguageName, practiceLanguageName),
    },
    {
      title: "Common Daily Actions",
      prompt:
        promptIntro(userLanguageName, practiceLanguageName) +
        `to use verbs in common daily actions in ${practiceLanguageName}. 
      Cover verbs like 'eat', 'sleep', 'come', and 'leave'. Provide examples in typical daily contexts, such as 'I eat breakfast', 'She sleeps late', or 'We come in peace'.` +
        promptEnd(userLanguageName, practiceLanguageName),
    },
    {
      title: "Asking Questions",
      prompt:
        promptIntro(userLanguageName, practiceLanguageName) +
        `to ask questions using common verbs in ${practiceLanguageName}. 
      Teach how to construct basic questions like 'Do you have?', 'Can I go?', 'Is he here?', and 'Will they do it?'. Explain the structure of questions and the role of auxiliary verbs.` +
        promptEnd(userLanguageName, practiceLanguageName),
    },
  ],
};
